import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ReportInlineModuleError } from '@americanexpress/travel-error-base';
import { useSelector } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { MODULE_NAME } from '../../constants/modules';

export const PersonalizedContentError = ({
  hasTravelerError,
}) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  if (isLoggedIn && hasTravelerError) {
    return (
      <ReportInlineModuleError moduleID={MODULE_NAME} otherData={{ component: 'PersonalizedContentError' }}>
        <div className="pad-3-t margin-3-b-md-down pad-responsive-lr pad-0-lr-lg-up">
          <ErrorMessage
            message={<FormattedMessage id="error.unableToLoadPersonalizedContentMessage" />}
          />
        </div>
      </ReportInlineModuleError>
    );
  }
  return null;
};

PersonalizedContentError.propTypes = {
  hasTravelerError: PropTypes.bool.isRequired,
};
